<template>
  <div class="containerCButtons">
    <span>
      <el-button
        v-for="(item, index) in dButtons1"
        :key="index"
        @click="fnButtons1(item)"
        :style="cssVars"
        :class="item == defaultVal ? 'checkedBtnStyle' : ''"
        class="noActive"
        size="mini">
        <template #default>
          {{ item }}
          <slot name="tooltip" :item="item"> </slot>
        </template>
      </el-button>
    </span>
  </div>
</template>

<script>
export default {
  // 从父组件传值的
  props: {
    dButtons1: {
      type: Array,
      default: '',
    },
    defaultVal: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'normal',
    },
  },
  methods: {
    fnButtons1(val) {
      this.$emit('Cbtns', val);
    },
  },
  components: {},
  computed: {
    cssVars() {
      if (this.size == 'mini') {
        return 'font-size:12px;';
      }
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.containerCButtons {
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  font-weight: 400;
  letter-spacing: 0.25px;
  line-height: calc(var(--ROOTFONTFIZE) * (20 / 144));
  color: rgba(255, 255, 255, 1);
  display: flex;
  align-items: center;
}

span {
  background-color: var(--buttons_bgc);
  box-sizing: border-box;
  height: calc(var(--ROOTFONTFIZE) * (40 / 144));
  display: flex;
  align-items: center;
  border-radius: 6px;
  padding: 0 calc(var(--ROOTFONTFIZE) * (5 / 144));
}

.el-button {
  min-width: 101px;
  font-size: calc(var(--ROOTFONTFIZE) * (16 / 144));
  font-weight: 400;
  letter-spacing: 0.1px;
  height: calc(var(--ROOTFONTFIZE) * (30 / 144));
  padding: calc(var(--ROOTFONTFIZE) * (7 / 144)) calc(var(--ROOTFONTFIZE) * (15 / 144));
}

.noActive {
  background-color: transparent;
  color: var(--buttons_noActive_color);
  border: none;
}

.checkedBtnStyle {
  background-color: var(--primary-color) !important;
  color: var(--table_bgc) !important;
}

.el-button:hover {
  background-color: var(--primary-color) !important;
  color: var(--table_bgc) !important;
}
</style>
